/**
 * Events Service
 * Delegates to analyticsService for unified event tracking
 * Kept for backward compatibility
 */
import { analyticsService } from './analyticsService';

export type SystemEventType =
  | 'app_launch_web'
  | 'session_restore_attempt'
  | 'session_restore_success'
  | 'session_restore_failed';

export interface AppLaunchEvent {
  type: 'app_launch_web';
  has_session_cookie: boolean;
  launch_index: number;
  is_first_launch: boolean;
  timestamp: string;
}

export interface SessionRestoreAttemptEvent {
  type: 'session_restore_attempt';
  has_session_cookie: boolean;
  timestamp: string;
}

export interface SessionRestoreSuccessEvent {
  type: 'session_restore_success';
  timestamp: string;
}

export interface SessionRestoreFailedEvent {
  type: 'session_restore_failed';
  reason: string;
  timestamp: string;
}

export type SystemEvent =
  | AppLaunchEvent
  | SessionRestoreAttemptEvent
  | SessionRestoreSuccessEvent
  | SessionRestoreFailedEvent;

export const eventsService = {
  /**
   * Emit a system event - delegates to analyticsService
   */
  emit(event: SystemEvent): void {
    const { type, ...rest } = event;
    analyticsService.track(type, rest, 'SYS-001');
  },

  timestamp(): string {
    return new Date().toISOString();
  },

  emitAppLaunch(params: {
    has_session_cookie: boolean;
    launch_index: number;
    is_first_launch: boolean;
  }): void {
    analyticsService.trackAppLaunch(params);
  },

  emitSessionRestoreAttempt(has_session_cookie: boolean): void {
    analyticsService.track('session_restore_attempt', { has_session_cookie }, 'SYS-001');
  },

  emitSessionRestoreSuccess(): void {
    analyticsService.trackSessionRestoreSuccess();
  },

  emitSessionRestoreFailed(reason: string): void {
    analyticsService.trackSessionRestoreFailed(reason);
  },
};

export default eventsService;
